var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-box",style:({ top: _vm.top, left: _vm.left })},_vm._l((_vm.avatars),function(avatar,i){return _c('div',{key:i,staticClass:"color-box__button",class:{
      disabled: _vm.usedColors.includes(avatar.color) && avatar.color != _vm.currentColor,
      active: avatar.color === _vm.currentColor,
    },staticStyle:{"height":"32%","width":"32%"},style:({
      background: 'center / contain no-repeat url(' + avatar.avatar + ')' + avatar.color,
      cursor: _vm.usedColors.includes(avatar.color) ? 'unset' : 'pointer',
      boxShadow: '0 0 0 1px ' + avatar.color,
      border: '3px solid ' + avatar.color,
    }),attrs:{"data-color":avatar.color},on:{"click":function($event){_vm.changeColor($event);
      _vm.$emit('hide-modal', _vm.select);}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }